import request from '@/services/interceptor.js'



// Utente
export const get_datiUserInfo = () => {
    return request({
        url: '/user/info',
        method: 'get',
        loadingBar: true
    })
};

export const update_profilo = (dati) => {
    return request({
        url: '/user/profilo',
        method: 'put',
        data: dati,
        loadingBar: true
    })
};

export const cambia_password = (dati) => {
    return request({
        url: '/user/cambia-password',
        method: 'post',
        data: dati,
        loadingBar: true
    })
};

export const genera_embed_token_mio = () => {
    return request({ url: '/utenti/mio/embed-token', method: 'post', loadingBar: true })
};

export const revoca_embed_token_mio = () => {
    return request({ url: '/utenti/mio/embed-token', method: 'delete', loadingBar: true })
};

